import { Button } from '@vibTheme/components/_base/Button';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Dispatch, ReactNode, useState } from 'react';

export type VibDialogProps = DialogProps & {
  open: boolean;
  setIsOpen: Dispatch<React.SetStateAction<boolean>>;
  title: string;
  content?: string | ReactNode;
  cancelBtnText?: string;
  confirmBtnText?: string;
  confirmCallback?: () => Promise<void>;
  cancelCallback?: () => Promise<void>;
};

export const VibDialog = (props: VibDialogProps) => {
  const {
    open,
    setIsOpen,
    confirmCallback,
    cancelCallback,
    cancelBtnText,
    confirmBtnText,
    ...restProps
  } = props;

  const handleClose = () => setIsOpen(false);

  const [isLoading, setIsLoading] = useState(false);
  const handleConfirm = async () => {
    try {
      setIsLoading(true);
      await confirmCallback?.();
      handleClose();
    } finally {
      setIsLoading(false);
    }
  };

  const handleCancel = async () => {
    await cancelCallback?.();
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      {...restProps}
    >
      <div className="p-main">
        <DialogTitle id="alert-dialog-title" className="p-0">
          {props.title}
        </DialogTitle>
        <DialogContent className="p-0">
          <div id="alert-dialog-description" className="py-main">
            {props.content}
          </div>
        </DialogContent>
        <DialogActions className="flex justify-between sm:justify-end p-0">
          <Button variant="outlined" onClick={handleCancel}>
            {cancelBtnText || 'Cancelar'}
          </Button>
          <Button
            id="vib-dialog-confirm"
            onClick={handleConfirm}
            loading={isLoading}
          >
            {confirmBtnText || 'Confirmar'}
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
